import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/analytics'
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from 'config'
import {Common} from './js/common.js'
import { Analytics } from '@/js/Analytics.js'
import { handleError, reportError } from '@/js/utils/ErrorHandler.js'
import '@/assets/scss/style.scss'
import '@/assets/scss/font.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'


// 画面からは this.$handleError("076", e, { hideLoading: true }) で使う（docs/plan/error-display.md 4.A）
Vue.prototype.$handleError = function (siteNo, error, options) {
  return handleError(store, siteNo, error, options)
}

// 本番環境のみエラー内容をアナリティクスに送信（番号 000 = 箇所不明の未処理例外）
if( !config.isDebug ){
  Vue.config.errorHandler = (err, vm, info) => {
    reportError("000", err, { origin: "Vue2", info });
    Analytics.track('js_error', {
      message: String(err?.message || err).slice(0, 100),
      info,
      page_location: location.href,
    });
  };

  // 同期エラー（リソース読み込み含む）
  window.addEventListener('error', (event) => {
    // `event.error` が無いこともある（リソース系）
    const err = event?.error || new Error(event?.message || 'Unknown JS error');
    reportError("000", err, { origin: "window.error" });
  }, true);

  // 非同期の未処理Promise
  window.addEventListener('unhandledrejection', (event) => {
    reportError("000", event?.reason, { origin: "unhandledrejection" });
  });
}

Vue.config.devtools = true;
Vue.config.productionTip = false

Vue.directive('visible', function(el, binding) {
	el.style.visibility = !binding.value ? 'visible' : 'hidden';
});

firebase.initializeApp(config.firebaseConfig);
// firebase.analytics();

let blankAxios = axios.create()

const configMixin = Vue.mixin({
  created: function () {
    this.$config = config
    this.$common = Common
    this.$blankAxios = blankAxios
  }
})

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, PUT, OPTIONS';
axios.defaults.baseURL = config.domain;

Vue.use(VueAxios,axios)

new Vue({
  router,
  store,
  configMixin,
  render: h => h(App)
}).$mount('#app')

